import store from '../../store'

export function getContacts() {	
	const state = store.getState()
	return state.contacts
}

